var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.group && _vm.group.name)?_c('h3',[_vm._v(_vm._s(_vm.group.name))]):_vm._e()]),_c('div',[_c('div',{staticClass:"fm-tree"},[_c('branch',{attrs:{"parent-id":0}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }